import React from 'react';
const Home: React.FC = () => {
    return (
        <>
            <article className='banner'>
                <div className="banner-bar">
                    <img src="/banner.png" alt="banner" />
                </div>
            </article>
            <article className="content">
                <div className="summary">
                    <img src="/image 1.png" alt="" className="box" />
                    <h2>has strong pride over code quality</h2>
                    <p>
                        We specialized in Games Management System (GMS) and CRM platforms, with experience in building from ground up some of the largest system in used today.
                    </p>
                </div>
                <div className="summary">
                    <img src="/image 2.png" alt="" className="box" />
                </div>
                <div className="summary">
                    <img src="/image 3.png" alt="" className="box" />
                </div>
            </article>
            <article className="solution">
            </article>
        </>
    );
};

export default Home;